/*
 * @Author: leunghope
 * @Date: 2020-10-26 13:42:17
 * @LastEditTime: 2020-10-26 14:49:55
 * @LastEditors: leunghope
 * @Description: 
 */
let baseUrl = '';
if (process.env.NODE_ENV === 'development') {
     baseUrl = 'http://daifatu.nbrcol.com/api/';
} else if (process.env.NODE_ENV === 'production') {
    baseUrl = 'https://www.daifatu.com/api/';
    // baseUrl = 'http://www.wyh8888.cn/api/';
}

export {baseUrl};
